<app-modal
  [title]="'TSE Details' | trans:'terminals/tse-details-modal/header/title'"
  [compact]="true"
  maxWidth="600px"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else if (tseDetails) {
      <table class="base full-width wrap" #tseDetailsTable>
        <tbody>
        <tr>
          <td width="250px">
            <div>
              {{ 'Pin' | trans:'terminals/tse-details-modal/pin.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.pin }}
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'Puk' | trans:'terminals/tse-details-modal/puk.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.puk }}
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'ClientId' | trans:'terminals/tse-details-modal/clientId.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.clientId }}
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'PublicKey' | trans:'terminals/tse-details-modal/publicKey.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.publicKey }}
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'Certificate' | trans:'terminals/tse-details-modal/certificate.Label' }}:
            </div>
          </td>
          <td>
            <div>
              <p class="line-clamp text-overflow-ellipsis overflow-hidden certificate" #certificateText>
                {{ tseDetails.certificate }}
              </p>

              <button
                class="button button--sm button--secondary p-0 text-uppercase m-t-8"
                #readMoreButton
                (click)="certificateText.style.webkitLineClamp = 'unset'; readMoreButton.remove();"
              >
                {{ 'Read More' | trans:'erminals/tse-details-modal/read-more-button.Button' }}
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'SerialNumber' | trans:'terminals/tse-details-modal/serialNumber.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.serialNumber }}
            </div>
          </td>
        </tr>
        <tr>
          <td width="250px">
            <div>
              {{ 'TransactionCounter' | trans:'terminals/tse-details-modal/transactionCounter.Label' }}:
            </div>
          </td>
          <td>
            <div>
              {{ tseDetails.transactionCounter }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-space-between">
      <div class="d-flex gap-16">
        <button
          class="button button--md button--primary text-uppercase"
          [appCopyTableDetails]="tseDetailsTable?.nativeElement"
        >
          {{ 'Kopieren'| trans:'terminals/tse-details-modal/copy.Button' }}
        </button>
      </div>

      <div class="d-flex gap-16">
        <button
          class="button button--md button--primary-ghost text-uppercase"
          (click)="close()"
        >
          {{ 'Cancel' | trans:'terminals/tse-details-modal/cancel.Button' }}
        </button>
        <button
          class="button button--md button--primary text-uppercase"
          [disabled]="isExportGenerating()"
          (click)="generatedFile ? openFile() : exportTransactions()"
        >
          @if (generatedFile) {
            {{ 'Download' | trans:'terminals/tse-details-modal/download.Button' }}
          } @else {
            {{ 'Export Transactions' | trans:'terminals/tse-details-modal/exportTransactions.Button' }}
          }
        </button>
      </div>
    </div>
  </ng-container>
</app-modal>
